import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Anchor, Grid } from 'antd'

import { useSearchContext } from '@/contexts/search/useSearchContext'
import { VERY_SMALL_DEVICE_WIDTH } from '@/libs/constants'

const { useBreakpoint } = Grid

const { Link } = Anchor

const anchorTop = {
  xxl: 208,
  xl: 208,
  lg: 114, // 110
  md: 114, // 110
  sm: 114, // 110
  xs: 114, // 110
}

const anchorMarginTop = {
  xxl: 204,
  xl: 204,
  lg: 200, // 132
  md: 157, // 132
  sm: 217, // 132
  xs: 223, // 132
}

function calcHeaderHeight(breakpointObject, isSearchFocused) {
  // convert object of breakpoint into array
  const breakpoints = Object.entries(breakpointObject)
  // get the first found breakpoint from sorted array
  const breakpoint = breakpoints.length > 0
    && breakpoints.reverse().find(([, value]) => !!value)
  // "breakpoint" contains [key, value]. Ex: ["sm", true]
  // "breakpoint[0]" is the key. Ex: "sm"
  // in case "breakpoint" is undefined, can not get the key
  if (breakpoint) {
    if (breakpoint[0] === 'xs' && window.innerWidth > VERY_SMALL_DEVICE_WIDTH) {
      return isSearchFocused ? 237 : 185
    }

    return isSearchFocused
      ? anchorMarginTop[breakpoint[0]]
      : anchorTop[breakpoint[0]]
  }
  return 116
}

interface B2becAnchorProps {
  listKeys: {
    key: string
    translationKey: string
  }[]
  anchorOffset?: number
}

function B2becAnchor({ listKeys, anchorOffset = 50 }: B2becAnchorProps) {
  const { t } = useTranslation()
  const { isSearchFocused } = useSearchContext()
  const breakpoint = useBreakpoint()
  const headerHeight = calcHeaderHeight(breakpoint, isSearchFocused)

  return (
    <Anchor
      className="custom-anchor"
      offsetTop={headerHeight}
      targetOffset={headerHeight + anchorOffset}
    >
      {listKeys.map((panelData) => (
        <Link
          key={panelData.key}
          className="custom-anchor__link"
          href={`#${panelData.key}`}
          title={t(panelData.translationKey)}
        />
      ))}
    </Anchor>
  )
}

export default B2becAnchor
